import * as TogglePrimitive from "@radix-ui/react-toggle";
import * as React from "react";
import { cx } from "../internal/cx.js";

export type ToggleSize = "sm" | "md" | "lg";
export type ToggleVariant = "default" | "outline";

export interface ToggleProps extends React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> {
  size?: ToggleSize;
  variant?: ToggleVariant;
}

/**
 * Pressable two-state button (e.g., a bold/italic toolbar button). The
 * pressed state persists until clicked again — unlike `<Button>`, which
 * has no on/off concept. For a labeled boolean preference, prefer
 * `<Switch>`; for a set of mutually-exclusive options, prefer
 * `<ToggleGroup>` (lifted as a molecule).
 */
export const Toggle = React.forwardRef<React.ElementRef<typeof TogglePrimitive.Root>, ToggleProps>(
  function Toggle({ className, size = "md", variant = "default", ...props }, ref) {
    return (
      <TogglePrimitive.Root
        ref={ref}
        className={cx(
          "cw-v2-toggle",
          `cw-v2-toggle--${variant}`,
          `cw-v2-toggle--${size}`,
          className,
        )}
        {...props}
      />
    );
  },
);
Toggle.displayName = "Toggle";
